/*
 * @Author: yaoyuting
 * @Date: 2019-08-30 02:02:10
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-12 14:56:53
 * @Descripttion:
 */
import Vue from "vue";
import Router from "vue-router";
import { goPAGE } from "./utils/utils";

Vue.use(Router);

const classify = goPAGE();
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: `/${classify}/Index`,
    },
    {
      path: "/pc",
      name: "home",
      component: () => import("./views/pc/Home"),
      children: [
        {
          path: "/pc/Index", //首页
          name: "Index",
          component: () => import("./views/pc/Index"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/StartBuilding", //开始建造
          name: "StartBuilding",
          component: () => import("./views/pc/Developer/StartBuilding.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Overview", //Overview
          name: "Overview",
          component: () => import("./views/pc/Learning/Overview.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Wallet", //钱包
          name: "Wallet",
          component: () => import("./views/pc/Learning/Wallet.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Ecological", //生态发展
          name: "Ecological",
          component: () => import("./views/pc/Ecological.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Group", //加入集体
          name: "Ecological",
          component: () => import("./views/pc/Community/Group.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Email", //邮箱
          name: "Email",
          component: () => import("./views/pc/Community/Email.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Rule", //申请流程
          name: "Email",
          component: () => import("./views/pc/Fund/Rule.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Grant", //声明
          name: "Grant",
          component: () => import("./views/pc/Fund/Grant.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Form1", //声明
          name: "Form1",
          component: () => import("./views/pc/Fund/Form1.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Foundation", //资金申请第一步
          name: "Foundation",
          component: () => import("./views/pc/Ecological/Foundation.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Foundationa", //资金申请第二步
          name: "Foundationa",
          component: () => import("./views/pc/Ecological/Foundationa.vue"),
          meta: {
            alive: true,
          },
        },

        {
          path: "/pc/Foundationd", //资金申请第五步
          name: "Foundationd",
          component: () => import("./views/pc/Ecological/Foundationd.vue"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/pc/Application", //合约
          name: "Application",
          component: () => import("./views/pc/Application.vue"),
          meta: {
            alive: false,
          },
        },
        {
          path: "/pc/Applicationa", //合约12步骤
          name: "Applicationa",
          component: () => import("./views/pc/Applicationa.vue"),
          meta: {
            alive: false,
          },
        },
        {
          path: "/pc/Applicationb", //合约12步骤
          name: "Applicationb",
          component: () => import("./views/pc/Applicationb.vue"),
          meta: {
            alive: false,
          },
        },{
          path: "/pc/Applicationc", //合约12步骤
          name: "Applicationc",
          component: () => import("./views/pc/Applicationc.vue"),
          meta: {
            alive: false,
          }        
        } , {
          path: "/pc/Applicationd", //合约12步骤
          name: "Applicationd",
          component: () => import("./views/pc/Applicationd.vue"),
          meta: {
            alive: false,
          },
        }
      ],
    },

    {
      path: "/m",
      name: "home",
      component: () => import("./views/m/Home"),
      children: [
        {
          path: "/m/Index",
          name: "Index",
          component: () => import("./views/m/Index"),
          meta: {
            alive: true,
          },
        },
        //  {
        //   path: '/m/NoSearch',
        //   name: 'NoSearch',
        //   component: () => import('./views/m/NoSearch'),
        // }
        {
          path: "/m/Learning/Overview",
          name: "Overview",
          component: () => import("./views/m/Learning/Overview"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Learning/Wallet",
          name: "Wallet",
          component: () => import("./views/m/Learning/Wallet"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Learning/Ecological",
          name: "Ecological",
          component: () => import("./views/m/Learning/Ecological"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Learning/Join",
          name: "Join",
          component: () => import("./views/m/Learning/Join"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Learning/Community",
          name: "Community",
          component: () => import("./views/m/Learning/Community"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Learning/building",
          name: "building",
          component: () => import("./views/m/Learning/building"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Ecological/Foundation", //资金申请第一步
          name: "Foundation",
          component: () => import("./views/m/Ecological/Foundation"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Ecological/Foundationa", //资金申请第二步
          name: "Foundationa",
          component: () => import("./views/m/Ecological/Foundationa"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Ecological/Foundationb", //资金申请第三步
          name: "Foundationb",
          component: () => import("./views/m/Ecological/Foundationb"),
          meta: {
            alive: true,
          },
        },
        {
          path: "/m/Application/Application", //资金申请第三步
          name: "Application",
          component: () => import("./views/m/Application/Application"),
          meta: {
            alive: false,
          },
        
        },
        {
          path: "/m/Application/Applicationa", //资金申请第三步
          name: "Applicationa",
          component: () => import("./views/m/Application/Applicationa"),
          meta: {
            alive: false,
          },
        
        },
        {
          path: "/m/Application/Applicationc", //资金申请第三步
          name: "Applicationc",
          component: () => import("./views/m/Application/Applicationc"),
          meta: {
            alive: false,
          },
        
        },
        {
          path: "/m/Application/Applicationb", //资金申请第三步
          name: "Applicationb",
          component: () => import("./views/m/Application/Applicationb"),
          meta: {
            alive: false,
          },
        
        },
        {
          path: "/m/Application/Applicationd", //资金申请第三步
          name: "Applicationd",
          component: () => import("./views/m/Application/Applicationd"),
          meta: {
            alive: false,
          },
        
        },
        
        // {
        //   path: '/m/Ecological/Foundationc',//资金申请第四步
        //   name: 'building',
        //   component: () => import('./views/m/Ecological/Foundationc'),
        // },
        // {
        //   path: '/m/Ecological/Foundationd',//资金申请第五步
        //   name: 'building',
        //   component: () => import('./views/m/Ecological/Foundationd'),
        // }
      ],
    },
  ],
});
